import { useEffect, useState } from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import { Typography, Grid, Paper, useTheme } from '@mui/material';

import api from '../../services/api';

import { toast } from 'react-toastify';
import { getStyled } from './styles';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const ChartsRushHour = ({ dateFrom, dateTo }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    async function handleChangeReportData() {
      try {
        const { data } = await api.get(
          `/reports/rushHour?initialDate=${dateFrom}&finalDate=${dateTo}`,
        );

        setChartData(data);
      } catch (err) {
        console.error(err);
        toastError('Erro ao obter informações dos atendimentos');
      }
    }

    handleChangeReportData();
  }, [dateFrom, dateTo]);

  const data = {
    labels:
      chartData.length > 0
        ? chartData.map(
            (item) => `${item.message_hour}:00 às ${item.message_hour}:59`,
          )
        : 0,
    datasets: [
      {
        label: 'Quantidade',
        data:
          chartData.length > 0
            ? chartData.map((item) => item.message_count)
            : 0,
        backgroundColor: 'transparent',
        borderColor: theme.palette.mode === 'light' ? '#053A5E' : '#1D9FF0',
        borderWidth: 1,
        fill: true,
      },
    ],
  };

  return (
    <Grid size={{ xs: 12 }} style={{ marginTop: 8, marginBottom: 8 }}>
      <Paper style={classes.fixedHeightPaper2}>
        <Typography
          component='h2'
          variant='h6'
          sx={{
            color:
              theme.palette.mode === 'dark'
                ? '#FFF'
                : theme.palette.primary.main,
          }}
          gutterBottom
        >
          Horário de Pico - Troca de mensagens
        </Typography>
        <span style={{ fontSize: 13, color: '#bcbcbc' }}>
          Quantidade de mensagens recebidas e enviados em cada hora do dia.
          <br />
          <span
            style={{ fontSize: 10, fontWeight: 'lighter', color: '#bcbcbc' }}
          >
            Obs.: Quando mais de um dia no filtro, o demonstrativo é de soma de
            cada horário em todos os dias.
          </span>
        </span>

        <Line
          data={data}
          options={classes.chartsRushHourOptions}
          height={100}
        />
      </Paper>
    </Grid>
  );
};

export default ChartsRushHour;
